import { useI18n } from '@/hooks/useI18n';
import { formatoFecha } from '@/i18n/formato';
import { anuncioPro, ceremoniaPendiente } from './datosDelAnuncio';
import styles from './AnuncioPro.module.css';

/**
 * El reconocimiento LAS 100 PRO 2026, como anuncio breve al pie del sitio.
 *
 * Va en el footer y no en la home por criterio de tono: una franja de premio
 * arriba del titular le habla al ecosistema emprendedor, y quien entra a este
 * sitio viene a evaluar a un proveedor. Abajo funciona como funcionan las
 * credenciales en un sitio de empresa —se encuentra quien la busca, y no
 * interrumpe a quien no—. Por eso también es texto denso y no una tarjeta con
 * botón: aquí abajo un botón grande pediría atención que el lugar no tiene.
 *
 * Al vivir en el footer sale en todas las páginas públicas, no sólo en la home.
 *
 * **Aquí hubo una liga de registro y Alan la quitó el 2026-09-21.** Iba a
 * `tinyurl.com/las100pro`, que redirige a un formulario de Google. Se fue
 * entera: el enlace, su texto en los dos diccionarios y su regla de CSS. Si
 * alguien la echa de menos, está en el historial de git, no en un comentario.
 *
 * Lo que queda de la premiación es el dato —cuándo y dónde—, y **se retira solo**
 * pasada la fecha; el reconocimiento se queda. Es la única parte con
 * vencimiento: anunciar una premiación ya ocurrida envejece igual de mal que
 * mandar a un formulario cerrado. El corte está en `ceremoniaPendiente()`.
 */
export function AnuncioPro() {
  const { t, locale } = useI18n();
  const a = t.marketing.reconocimiento;

  // Con el día de la semana ('jueves, 19 de noviembre'): es el dato con el que
  // la gente decide si le queda la agenda, y cabe en la misma línea.
  const fecha = formatoFecha(locale, anuncioPro.fechaCeremonia, { dateStyle: 'full' });

  return (
    <aside className={styles.anuncio} aria-labelledby="anuncio-pro-titulo">
      {/*
        El distintivo es contenido, no adorno: es la prueba de lo que dice la
        línea de al lado. Por eso lleva `alt` de verdad, al revés que los logos
        de aliados de la home.
      */}
      <img
        src={anuncioPro.logo}
        alt={a.logoAlt}
        className={styles.distintivo}
        width={1024}
        height={581}
        loading="lazy"
      />

      <div className={styles.texto}>
        <p id="anuncio-pro-titulo" className={styles.titulo}>
          {a.titulo}
        </p>

        <p className={styles.cuerpo}>{a.cuerpo}</p>

        {ceremoniaPendiente() && (
          <p className={styles.premiacion}>
            <span className={styles.premiacionDatos}>
              {a.premiacionEtiqueta}{' '}
              <time dateTime={anuncioPro.fechaCeremonia.slice(0, 10)}>{fecha}</time>
              {a.premiacionSeparador}
              {a.premiacionLugar}
            </span>
          </p>
        )}

        <p className={styles.gracias}>{a.gracias}</p>
      </div>
    </aside>
  );
}
